export default __webpack_public_path__ + "static/media/logo.ec40bd34.png";